import { render, staticRenderFns } from "./VCabecalho.vue?vue&type=template&id=d6d5b8c6"
import script from "./VCabecalho.vue?vue&type=script&lang=js"
export * from "./VCabecalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports